/**
 * Created by razial on 18.09.2026.
 */

Mission.TYPE_EXPEDITION_PASS = 44;

ManualStarters.MissionTreeStarter = function (type, options) {
    return options && options.fromMissionTree;
};

Mission.REGISTRATIONS.set(Mission.TYPE_EXPEDITION_PASS, () => ({
    name: "ExpeditionPass",
    view: ExpeditionPassWindow,
    startWindow: ExpeditionPassWindow,
    finishWindow: ExpeditionPassWindow,
    guideWindow: ExpeditionPassRulesOptions,
    sideBarJson: function () {
        return cleverapps.skins.getSlot("expedition_buildpass_icon_json");
    },
    logic: PassMissionLogic,
    levels: PassLevelsConfig.expeditionpass,
    sideBarSlotName: "expeditionBuildPassSideBarIcon",
    lastChanceView: PassLastChanceWindow,
    collectIcon: function () {
        return cleverapps.skins.getSlot("pass_star_png") || bundles.reward_icons_pass.frames.pass_star_png;
    },
    collectItemName: "star",
    mapPoints: true,
    eventPrefix: function () {
        return cleverapps.meta.selectedLocationId();
    },
    manualStart: ManualStarters.MissionTreeStarter,
    manualFinish: true,
    mainWorldReward: true
}));
